import type { ProtonThunkArguments } from '@proton/redux-shared-store-types';

export interface AccountThunkArguments extends ProtonThunkArguments {}

export const extraThunkArguments = {} as AccountThunkArguments;
